import { useContext, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { Link } from 'react-router-dom';
import PopUp from 'src/components/AppealForm/Qualifications/PopUp';
import RadioButton from 'src/components/AppealForm/Qualifications/RadioButton';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import FormContext from 'src/contexts/real-property-appeal-context';

export default function Qualifications() {
  const [checked, setChecked] = useState({});
  const [open, setOpen] = useState(false);
  const { setDisableNext } = useContext(FormContext);
  const form = useFormikContext();

  const allYesSelected = () => {
    const values = Object.values(form.values);
    return !(values.every((val) => val === 'yes') && values.length === 5);
  };

  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSelect = (name, selection) => {
    setChecked((prev) => {
      return { ...prev, [name]: selection };
    });
  };

  useEffect(() => {
    setDisableNext(allYesSelected());
  }, [checked]);

  return (
    <>
      <PopUp isOpen={open} handleClose={handleClose} />
      <Section title="Qualifications for Reduction of Late Payment">
        <Subheader>
          To complete the appeal form, each of the conditions below must be met and answered with a
          &quot;Yes&quot;
        </Subheader>
        <RadioButton
          handleSelect={handleSelect}
          name="notCausedByCountyError"
          openPopUp={handleOpen}
        >
          The assessment of the penalty was <b>NOT</b> caused by a County error
        </RadioButton>
        <RadioButton handleSelect={handleSelect} name="paidInFull" openPopUp={handleOpen}>
          <b>ALL</b> taxes for all prior years have been paid in full
        </RadioButton>
        <RadioButton handleSelect={handleSelect} name="penaltyDueToFailure" openPopUp={handleOpen}>
          The penalty has been assessed because of a failure to meet Property Tax due date
          requirements outlined in{' '}
          <Link
            className="font-medium text-blue-600 hover:underline dark:text-blue-500"
            to={`/property-tax-due-date`}
            rel="noreferrer"
            target="_blank"
          >
            UCA Section 59-2-1331
          </Link>
        </RadioButton>
        <RadioButton handleSelect={handleSelect} name="doesNotExceed2500" openPopUp={handleOpen}>
          The tax amount for the subject year does not exceed five thousand dollars ($5,000.00)
        </RadioButton>
        <RadioButton
          handleSelect={handleSelect}
          name="noPenaltyPriorThreeYears"
          openPopUp={handleOpen}
        >
          The current owner has not been assessed a penalty under{' '}
          <Link
            className="font-medium text-blue-600 hover:underline dark:text-blue-500"
            to={`/property-tax-due-date`}
            rel="noreferrer"
            target="_blank"
          >
            UCA Section 59-2-1331
          </Link>
          , related to any of the prior three (3) tax years
        </RadioButton>
        <h5 className="text-center">
          <p>IF YOU QUALIFY, YOU WILL RECEIVE A ONE-TIME REDUCTION OF THE PENALTY.</p>
        </h5>
      </Section>
    </>
  );
}
